export default __webpack_public_path__ + "static/media/price-1.7c0f1c93.png";